import { CheckCircle2 } from "lucide-react";

interface PeppolIdDisplayProps {
  peppolId: string;
}

export const PeppolIdDisplay = ({ peppolId }: PeppolIdDisplayProps) => {
  return (
    <div className="bg-secondary/50 border border-primary/20 rounded-lg p-4 space-y-2">
      <div className="flex items-center gap-2">
        <CheckCircle2 className="h-4 w-4 text-success" />
        <span className="text-sm font-medium text-muted-foreground">
          Peppol ID Created and Registered:
        </span>
      </div>
      <div className="flex items-center gap-2">
        <span className="text-sm font-medium text-muted-foreground">Peppol ID:</span>
        <span className="text-lg font-semibold text-primary">{peppolId}</span>
      </div>
    </div>
  );
};
